import React, { useState, useEffect } from 'react'
import './styles/Table.css'
import MaterialTable from 'material-table'
// import GetAppIcon from '@material-ui/icons/GetApp'
// import FileUploadIcon from '@mui/icons-material/FileUpload'
import DeleteIcon from '@mui/icons-material/Delete'
import { Grid } from '@material-ui/core'
// import Swal from 'sweetalert2'
// import swal from 'sweetalert'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

// importamos el contexto para extraer la data de ahi

import { useAuthentication } from '../../../../context/authenticationContext'
import { getMIPYMESWITHIFIS } from '../../../../services/Representacion/get'
import { ModalRepresentationIFI } from './Modal/ModalRepresentationIFI'
const TableFormularios = () => {
  const { userIDB2C } = useAuthentication()
  const [loading, setLoading] = useState(true)
  const [open, setOpen] = useState(false)
  const [rowData, setRowData] = useState('')

  useEffect(() => {
    // setLoading(true)
    getMIPYMESRepresentadas()
  }, [])

  const getMIPYMESRepresentadas = async () => {
    try {
      const response = await getMIPYMESWITHIFIS(userIDB2C)
      if (response.Success) {
        if (response.Data.length > 0) {
          setTableForms(response.Data)
        } else {
          setTableForms([])
        }
      }
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
    setLoading(false)
  }

  const columns = [
    // {
    //   title: 'IdForm',
    //   field: 'IdForm',
    //   sorting: true,
    //   filtering: true,
    //   // cellStyle: { background: '#009688' },
    //   // headerStyle: { color: '#fff' },
    // },
    {
      title: 'Identificador',
      field: 'TaxRegistration',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Nombre IFI',
      field: 'IFIName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Nombre MIPYME',
      field: 'MiPymeName',
      sorting: true,
      filtering: true,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
  ]
  // downloadPDF, loadingPDF

  const [TableForms, setTableForms] = useState([])

  return (
    <section>
      {!loading ? (
        <Grid
          container
          style={{
            width: '100%',
            height: 'auto',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              height: 'auto',
              width: '96%',
              backgroundColor: '#fff',
              borderRadius: '4px',
            }}
          >
            <div className="App">
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={12}>
                  <MaterialTable
                    columns={columns}
                    data={TableForms}
                    actions={[
                      {
                        icon: () => <DeleteIcon color="error" />,
                        tooltip: 'Eliminar',
                        onClick: (event, rowData) => {
                          setOpen(true)
                          setRowData(rowData)
                        },
                      },
                    ]}
                    onSelectionChange={(selectedRows) =>
                      console.log(selectedRows)
                    }
                    options={{
                      sorting: true,
                      search: true,
                      searchFieldAlignment: 'right',
                      searchAutoFocus: true,
                      searchFieldVariant: 'standard',
                      filtering: true,
                      paging: true,
                      pageSizeOptions: [2, 5, 10, 20],
                      pageSize: 5,
                      paginationType: 'stepped',
                      showFirstLastPageButtons: false,
                      paginationPosition: 'bottom',
                      exportButton: true,
                      exportAllData: true,
                      exportFileName: 'TableData',
                      // addRowPosition: 'first',
                      actionsColumnIndex: -1,
                      selection: false,
                      showSelectAllCheckbox: false,
                      showTextRowsSelected: false,
                      selectionProps: (rowData) => ({
                        disabled: rowData.age == null,
                        // color:"primary"
                      }),
                      // grouping: true,
                      columnsButton: true,
                      rowStyle: (data, index) =>
                        index % 2 === 0 ? { background: '#f5f5f5' } : null,
                      headerStyle: { background: '#014b96', color: '#fff' },
                    }}
                    localization={{
                      body: {
                        editRow: {
                          deleteText: '¿Está seguro de eliminar el registro?',
                        },
                      },
                      header: {
                        actions: 'Acciones',
                      },
                      toolbar: {
                        searchPlaceholder: 'Buscar',
                      },
                    }}
                    title=" "
                  />
                </Grid>
              </Grid>
            </div>
          </div>
          <ModalRepresentationIFI
            open={open}
            setOpen={setOpen}
            rowData={rowData}
            getMIPYMESRepresentadas={getMIPYMESRepresentadas}
          />
        </Grid>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </section>
  )
}
export default TableFormularios
